<template>
    <section id="businessThankYouSreen">
        <div class="container">
            <div class="logo">
                <img :src="`${publicPath}img/shaves_logo.svg`" alt>
            </div>
            <div class="textCopy">
                <h4>Shaves Digital Loyalty card</h4>
                <h2>Add to your wallet</h2>
                <p class="primary">We've made it even simpler to get great discounts & benefits.</p>
                <form action="#" autocomplete="off">
                    <div class="columns">
                        <div class="column is-half-desktop">
                            <div class="control">
                                <label for="email">
                                    Email Address
                                    <span>*</span>
                                </label>
                                <input :disabled="loading" v-validate="'required|email'" v-model="email"
                                    :class="{ 'invalid': emailExists }" @focus="clearError('email')" id="email"
                                    class="input" type="email" required v-on:keyup.enter="focusOut($event)">
                            </div>
                        </div>
                    </div>
                </form>
                <div class="wallet-buttons mobile-app-buttons" :class="{'disabled': !email || loading}">
                    <button @click="applyAPI">
                        <img :src="`${publicPath}img/apple_wallet.svg`" alt="Add to apple wallet icon">
                    </button>
                    <button @click="googleAPI">
                        <img :src="`${publicPath}img/google_wallet.svg`" alt="Add to google wallet icon">
                    </button>
                </div>
                <p v-if="!fromEmail">This registration will close & clear all information in {{ secondsRemaining }} seconds</p>
            </div>
        </div>
    </section>
</template>

<script>
import alertify from "alertifyjs";
import axios from "axios";
import { mask } from "vue-the-mask";
import { isKiosk, isTaggedVisit, isPhoneSized } from "../../kiosk";
export default {
    name: "AddToWallet",
    directives: { mask },
    data() {
        return {
            publicPath: process.env.BASE_URL,
            email: null,
            emailExists: false,
            loading: false,
            secondsRemaining: 60,
            timer: null,
        };
    },
    components: {
    },
    methods: {
        applyAPI() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.loading = false;
                    alertify.error("Please check all fields are filled in correctly.");
                } else {
                    this.loading = true;
                    axios
                        .post(
                            this.$store.state.apiBaseUrl + `/apple-loyalty-card/`, {
                                email: this.email
                            }
                        )
                        .then(res => {
                            console.log("ALL GOOD", res)
                            this.loading = false
                            this.$store.state.loyaltyCard = res;
                            this.$store.commit("SAVE_LOYALTY_INFORMATION", res);
                            if (this.isOwnDevice) {
                                // Same tab: Safari shows the Add to Apple Wallet sheet for the .pkpass
                                window.location.href = `${this.$store.state.apiBaseUrl}/apple-loyalty-card/${res.data.wallet_url}`;
                            } else {
                                this.$router.push({ path: "/digital-loyalty-scan", query: this.sourceQuery });
                            }
                        })
                        .catch(err => {
                            alertify.error("Error: " + err);
                            this.loading = false
                        })
                }
            });
        },
        googleAPI() {
            this.$validator.validate().then(result => {
                if (!result) {
                    this.loading = false;
                    alertify.error("Please check all fields are filled in correctly.");
                } else {
                    this.loading = true;
                    axios
                        .post(
                            this.$store.state.apiBaseUrl + `/google-loyalty-card/`, {
                                email: this.email
                            }
                        )
                        .then(res => {
                            console.log("ALL GOOD", res)
                            this.loading = false
                            this.$store.state.loyaltyCard = res;
                            this.$store.commit("SAVE_LOYALTY_INFORMATION", res);
                            if (this.isOwnDevice) {
                                window.location.href = res.data.wallet_url;
                            } else {
                                this.$router.push({ path: "/digital-loyalty-scan", query: this.sourceQuery });
                            }
                        })
                        .catch(err => {
                            alertify.error("Error: " + err);
                            this.loading = false
                        })
                }
            });
        },
        clearError(type) {
            if (type == 'email') {
                this.emailExists = false;
            }
        },
    },
    computed: {
        // Visitors from the welcome emails are on their own device, not the in-store kiosk
        fromEmail() {
            return this.$route.query.source === 'welcome-email';
        },
        sourceQuery() {
            return this.fromEmail ? { source: this.$route.query.source } : {};
        },
        isMobileDevice() {
            const ua = navigator.userAgent;
            // iPadOS reports itself as a Mac, so check for touch support too
            return /iPhone|iPod|iPad|Android|Mobi/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints > 1);
        },
        // Add the card straight to this device's wallet only when it's the customer's own
        // phone/tablet: a tagged link from our comms, or a phone-sized screen. The in-store
        // kiosk tablet and desktops show a QR code to scan instead. See src/kiosk.js.
        isOwnDevice() {
            return !isKiosk() && this.isMobileDevice && (isTaggedVisit() || isPhoneSized());
        }
    },
    mounted() {
        if (this.$route.query.email && this.$route.query.email !== 'undefined' && this.$route.query.email !== 'null') {
            this.email = this.$route.query.email
        } else {
            this.email = this.$store.state.business.contact.email
        }

        if (!this.fromEmail) {
            this.timer = setInterval(() => {
                this.secondsRemaining -= 1;
                if (this.secondsRemaining == 0) {
                    this.$router.push("/");
                }
            }, 1000);
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
    }
};
</script>
